import _jsx from"@babel/runtime/helpers/esm/jsx";import React from'react';/**
 * Prevent mouse events from bubbling up.
 *
 * Why is this needed? Because `onClick`, `onMouseDown`, and `onMouseUp` are 3 separate events.
 * To prevent a lot of code duplication, this component can stop all mouse events.
 * Plus, placing it in the component tree makes it more readable.
 */const StopPropagation=_ref=>{let{children,enabled=true}=_ref;const handler=e=>{if(enabled){e.stopPropagation();}};return/*#__PURE__*/ (// eslint-disable-next-line jsx-a11y/no-static-element-interactions
_jsx("div",{onClick:handler,onMouseDown:handler,onMouseUp:handler},void 0,children));};export default StopPropagation;